<template>
  <div class="customer-edit" v-if="isFormActive">
    <div class="columns">
      <div class="column is-12">
        <title-component
          class="is-uppercase"
          :size="1">
          <translate>Customer edit</translate>
        </title-component>
        <!-- Description -->
      </div>
    </div>
    <form-component
      v-for="formDescriptor in formDescriptors"
      :formDescriptor="formDescriptor"
      :formData="getFormDataForDescriptor(formDescriptor)"
      :key="formDescriptor.id">
    </form-component>
    <transition
      name="fade"
      appear
      appear-active-class="animated fadeIn"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
      :duration="{ enter: 200, leave: 200 }">
      <div v-if="error" class="notification is-danger">
        {{ error }}
      </div>
    </transition>
    <div class="field is-grouped">
      <p class="control">
        <submit-btn-component class="is-primary is-uppercase is-large" @submit="updateCustomer" v-translate>
          Update profile
        </submit-btn-component>
      </p>
      <p class="control">
        <button class="button is-danger is-outlined is-large" v-on:click="redirectTo(redirectPath)" v-translate>
          Cancel
        </button>
      </p>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import FormComponent from '@/components/form/FormComponent'
  import TitleComponent from '@/components/layout/TitleComponent'
  import router from '@/router/customer'
  import { formHandlerMixin, onKeyEnterMixin, setContainedHeightMixin } from '@/mixins/mixins'
  import SubmitBtnComponent from '@/components/layout/utility/SubmitBtnComponent'

  export default {
    name: 'customer-edit-view',
    mixins: [onKeyEnterMixin, formHandlerMixin, setContainedHeightMixin],
    data () {
      return {
        isFormActive: false,
        error: '',
        redirectPath: this.backlink || { name: 'InvoicingView' }
      }
    },
    props: {
      backlink: {
        required: false
      }
    },
    components: {
      SubmitBtnComponent,
      FormComponent,
      TitleComponent
    },
    computed: {
      ...mapState({
        formDescriptors: state => state.customerEditModule.CustomerEditFormDescriptors,
        formDatas: state => state.customerEditModule.CustomerEditFormDatas,
        authUser: state => state.authModule.authUser
      })
    },
    methods: {
      ...mapActions([
        'setupCustomerEditForm',
        'updateCustomerInformation',
        'clearData',
        'getCustomerProfile',
        'errorMessage',
        'successMessage'
      ]),
      redirectTo (destination) {
        router.push(destination)
      },
      updateCustomer (btn) {
        let requestData = {
          formDatas: this.formDatas,
          profileId: this.authUser.profile.id
        }
        this.submitRequest = this.updateCustomerInformation
        this.submitForm(requestData, btn, this.updateCustomerCallback)
      },
      updateCustomerCallback (response) {
        this.getCustomerProfile().catch((err) => {
          this.handleError(err)
        })
        this.successMessage('Profile updated')
        this.redirectTo(this.redirectPath)
      }
    },
    created () {
      this.setupCustomerEditForm(this.authUser.profile.id).then(() => {
        this.isFormActive = true
      }).catch((err) => {
        this.handleError(err)
      })
    },
    beforeDestroy: function () {
      this.clearData()
    }
  }
</script>

<style lang="sass" scoped>
.title
  margin-bottom: 0.4rem
</style>
